<template>
    <div v-if="visible">
        <div class="mask" v-show="visible" @click="close"></div>
        <div class="dialog" v-show="visible">
            <div class="dialog-body">
                <div class="dialog-body-title">
                    <h1><span class="line"></span> 各地答题量统计 <span class="line"></span></h1>
                    <p>{{yearSelect === `${currentYear}` ? '本年度' : `${yearSelect}年`}}全国共有  {{ yearSelect === `${currentYear}` ? count : currentHistoryYearCount }}  人参与答题</p>
                    <div class="type">
                        <div></div>
                        <div class="tab">
                            <template
                                v-if="yearSelect !== currentYear">
                                <div
                                    v-for="(item, index) in tabs"
                                    :key="`${index}`"
                                    @click="clickTabHandle(index)"
                                    class="tab-item"
                                    :class="{'active': tabActive === index}">{{ item }}</div>
                            </template>
                            <template
                                v-else-if="yearSelect === currentYear">
                                <div
                                    v-for="(item, index) in ['参与人数']"
                                    :key="`${index}`"
                                    class="tab-item">{{ item }}</div>
                            </template>
                        </div>
                        <div class="year-select" @click="showYearSelectHandle">
                            {{ yearSelect }}
                            <img src="./../assets/2024/arrow-down.png" width="12" />
                        </div>
                    </div>
                    <p v-if="tabActive === 0" class="history-descript">全国累计答题人次  {{ historyCount }}  </p>
                    <p v-if="tabActive === 1" class="history-descript border">参与千分率=（答题数/各省人口数）*1000‰<br />
                        各省人口数来源：2020年第七次全国人口普查</p>
                </div>
                <div class="tab-content" v-if="tabActive === 0">
                    <nut-row type="flex" class="header">
                        <nut-col :span="5">
                            <div @click="clickHandle(0)" class="flex-content flex-content-light" :class="{'active': activeIndex === 0}">
                                <span
                                    v-if="activeIndex === 0 && province.id === ''">请选择</span>
                                <span
                                    v-else-if="province.id !== ''">{{ province.name }}</span>
                                <span
                                    v-else>省份</span>
                            </div>
                        </nut-col>
                        <nut-col :span="5">
                            <div @click="clickHandle(1)" class="flex-content flex-content-light" :class="{'active': activeIndex === 1}">
                                <span
                                    v-if="activeIndex === 1 && city.id === ''">请选择</span>
                                <span
                                    v-else-if="city.id !== ''">{{ city.name }}</span>
                                <span
                                    v-else>城市</span>
                            </div>
                        </nut-col>
                        <nut-col :span="5">
                            <div @click="clickHandle(2)" class="flex-content flex-content-light" :class="{'active': activeIndex === 2}">
                                <span
                                    v-if="activeIndex === 2 && county.id === ''">请选择</span>
                                <span
                                    v-else-if="county.id !== ''">{{ county.name }}</span>
                                <span
                                    v-else>县/区</span>
                            </div>
                        </nut-col>
                        <nut-col :span="5">
                            <div @click="clickHandle(3)" class="flex-content flex-content-light" :class="{'active': activeIndex === 3}">
                                <span
                                    v-if="activeIndex === 3 && street.id === ''">乡镇/街道</span>
                                <span
                                    v-else-if="street.id !== ''">{{ street.name }}</span>
                                <span
                                    v-else>乡镇/街道</span>
                            </div>
                        </nut-col>
                    </nut-row>
                    <div v-if="activeIndex === 0">
                        <ol v-if="provinceList.length > 0" class="list">
                            <li class="list-item" :class="province.id === d.Value ? 'active' : ''" @click="clickHandle(0, d.Value, d.Label)" v-for="(d, i) in provinceList" :key="`province-${d.index}-${d.Value}`">
                                <div class="list-item--rank">
                                    <img v-if="i === 0" src="./../assets/rank-1.png" alt="第一" />
                                    <img v-else-if="i === 1" src="./../assets/rank-2.png" alt="第二" />
                                    <img v-else-if="i === 2" src="./../assets/rank-3.png" alt="第三" />
                                    <span v-else>{{ i + 1 }}</span>
                                </div>
                                <div class="list-item--name">
                                    <span>{{ d.Label }}</span>
                                </div>
                                <div class="list-item--right">
                                    <span>{{ d.count || 0 }}</span>
                                    <img src="./../assets/right-arrow.png" alt=""/>
                                </div>
                            </li>
                        </ol>
                        <div v-else-if="provinceList.length === 0 && loadingProvince" class="search-no-data">正在查询省份统计...</div>
                        <div v-else class="search-no-data">没有查询到省份统计</div>
                    </div>
                    <div v-else-if="activeIndex === 1">
                        <ol v-if="cityList.length > 0" class="list">
                            <li class="list-item" :class="city.id === d.Value ? 'active' : ''" @click="clickHandle(1, d.Value, d.Label)" v-for="(d, i) in cityList" :key="`city-${d.index}-${d.Value}`">
                                <div class="list-item--rank">
                                    <img v-if="i === 0" src="./../assets/rank-1.png" alt="第一" />
                                    <img v-else-if="i === 1" src="./../assets/rank-2.png" alt="第二" />
                                    <img v-else-if="i === 2" src="./../assets/rank-3.png" alt="第三" />
                                    <span v-else>{{ i + 1 }}</span>
                                </div>
                                <div class="list-item--name">
                                    <span>{{ d.Label }}</span>
                                </div>
                                <div class="list-item--right">
                                    <span>{{ d.count || 0 }}</span>
                                    <img src="./../assets/right-arrow.png" alt=""/>
                                </div>
                            </li>
                        </ol>
                        <div v-else-if="cityList.length === 0 && loadingCity" class="search-no-data">正在查询城市统计...</div>
                        <div v-else class="search-no-data">没有查询到城市统计</div>
                    </div>
                    <div v-else-if="activeIndex === 2">
                        <ol v-if="countyList.length > 0" class="list">
                            <li class="list-item" :class="county.id === d.Value ? 'active' : ''" @click="clickHandle(2, d.Value, d.Label)" v-for="(d, i) in countyList" :key="`county-${d.index}-${d.Value}`">
                                <div class="list-item--rank">
                                    <img v-if="i === 0" src="./../assets/rank-1.png" alt="第一" />
                                    <img v-else-if="i === 1" src="./../assets/rank-2.png" alt="第二" />
                                    <img v-else-if="i === 2" src="./../assets/rank-3.png" alt="第三" />
                                    <span v-else>{{ i + 1 }}</span>
                                </div>
                                <div class="list-item--name">
                                    <span>{{ d.Label }}</span>
                                </div>
                                <div class="list-item--right">
                                    <span>{{ d.count || 0 }}</span>
                                    <img src="./../assets/right-arrow.png" alt=""/>
                                </div>
                            </li>
                        </ol>
                        <div v-else-if="countyList.length === 0 && loadingCounty" class="search-no-data">正在查询县/区统计...</div>
                        <div v-else class="search-no-data">没有查询到县/区统计</div>
                    </div>
                    <div v-else-if="activeIndex === 3">
                        <ol v-if="streetList.length > 0" class="list">
                            <li class="list-item" :class="street.id === d.Value ? 'active' : ''" v-for="(d, i) in streetList" :key="`street-${d.index}-${d.Value}`">
                                <div class="list-item--rank">
                                    <img v-if="i === 0" src="./../assets/rank-1.png" alt="第一" />
                                    <img v-else-if="i === 1" src="./../assets/rank-2.png" alt="第二" />
                                    <img v-else-if="i === 2" src="./../assets/rank-3.png" alt="第三" />
                                    <span v-else>{{ i + 1 }}</span>
                                </div>
                                <div class="list-item--name">
                                    <span>{{ d.Label }}</span>
                                </div>
                                <div class="list-item--right">
                                    <span>{{ d.count || 0 }}</span>
                                </div>
                            </li>
                        </ol>
                        <div v-else-if="streetList.length === 0 && loadingStreet" class="search-no-data">正在查询乡镇/街道统计...</div>
                        <div v-else class="search-no-data">没有查询到乡镇/街道统计</div>
                    </div>
                </div>
                <div class="tab-content" v-if="tabActive === 1">
                    <ol v-if="percentageList[yearSelect] && percentageList[yearSelect].length > 0" class="list">
                        <li class="list-item" v-for="(d, i) in percentageList[yearSelect]" :key="`2-province-${d.index}-${d.label}`">
                            <div class="list-item--rank">
                                <img v-if="i === 0" src="./../assets/rank-1.png" alt="第一" />
                                <img v-else-if="i === 1" src="./../assets/rank-2.png" alt="第二" />
                                <img v-else-if="i === 2" src="./../assets/rank-3.png" alt="第三" />
                                <span v-else>{{ i + 1 }}</span>
                            </div>
                            <div class="list-item--name">
                                <span>{{ d.label }}</span>
                            </div>
                            <div class="list-item--right">
                                <span>{{ d.percentage }}‰</span>
                            </div>
                        </li>
                    </ol>
                    <div v-else-if="percentageList[yearSelect].length === 0 && loadingProvince" class="search-no-data">正在查询参与率统计...</div>
                    <div v-else class="search-no-data">没有查询到参与率统计</div>
                </div>
            </div>
            <div class="dialog-footer">
                <button @click="close">关闭</button>
            </div>
        </div>
        <nut-actionsheet :is-visible="showYearSelect" 
            @close="showYearSelect = false"
            :menu-items="yearList"
            @choose="chooseYear"
            cancelTxt="取消"
            :chooseTagValue="yearSelect"
        ></nut-actionsheet>
    </div>
</template>
<script>
import api from "@/api/rank"
import addressApi from "@/api/address"
// import signApi from "@/api/sign"
// import userApi from "@/api/user";
import rank1 from "@/assets/rank-1.png"
import rank2 from "@/assets/rank-2.png"
import rank3 from "@/assets/rank-3.png"
import { populationList, cloneObj } from "@/utils/index"

export default {
    name: 'NameEnter',
    // components: {
    //   HelloWorld
    // }
    props: {
        show: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            beginYear: '',
            currentYear: '',
            count: 0,
            historyCount: 0,
            currentHistoryYearCount: 0,
            visible: false,
            activeIndex: 0,
            rank1,
            rank2,
            rank3,
            loadingProvince: false,
            loadingCity: false,
            loadingCounty: false,
            loadingStreet: false,
            province: {
                id: '',
                name: '',
            },
            city: {
                id: '',
                name: '',
            },
            county: {
                id: '',
                name: '',
            },
            street: {
                id: '',
                name: '',
            },
            provinceList: [],
            cityList: [],
            countyList: [],
            streetList: [],
            percentageList: [],
            tabActive: 0,
            tabs: ['参与人数', '参与率'],
            yearList: [],
            yearSelect: '',
            showYearSelect: false,
            populationListMap: {},
            currentYearCount: 0, // 当前年总答题数
            cacheHistoryData: {},
            cachePercentageList: [],
        }
    },
    watch: {
        show: {
            handler(newValue, oldValue) {
                console.log(newValue, oldValue)
                if (newValue) {
                    const now = new Date()
                    // const currentYear = now.getFullYear()
                    const currentYear = Number(window.sessionStorage.getItem("currentYear")) || now.getFullYear()
                    const beginYear = 2024
                    const yearList = []
                    const cacheHistoryData = {}
                    const percentageList = {}
                    for (let i = currentYear; i >= beginYear; i--) {
                        yearList.push({
                            name: `${i}`,
                            value: currentYear - i,
                        })
                        cacheHistoryData[i] = {
                            province: [],
                            city: {},
                            county: {},
                            street: {},
                        }
                        percentageList[i] = []
                    }
                    this.percentageList = percentageList
                    if (JSON.stringify(this.cacheHistoryData) === '{}') {
                        this.cacheHistoryData = cacheHistoryData
                    }
                    this.yearList = yearList
                    this.beginYear = `${beginYear}`
                    this.currentYear = `${currentYear}`
                    this.val = ''
                    this.yearSelect = `${currentYear}`
                    this.provinceList = []
                    this.activeIndex = 0
                    this.tabActive = 0
                    this.province.id = ''
                    this.province.name = ''
                    this.resetCity()
                    this.resetCounty()
                    this.resetStreet()
                    document.body.classList.add('no-scroll')
                    if (JSON.stringify(this.populationListMap) === '{}') {
                        this.getPopulationList();
                    }
                    // if (this.historyCount === 0) {
                    this.getHistorySignCount()
                    // }
                    this.getProvinceRank()
                } else {
                    document.body.classList.remove('no-scroll')
                }
                this.visible = newValue
            },
            deep: true,
        }
    },
    mounted() {
        // const obj = new WxLogin({
        //   "self_redirect": true,
        //   id: "login_container", 
        //   appid: "", 
        //   scope: "", 
        //   "redirect_uri": "",
        //   state: "",
        //   style: "",
        //   href: ""
        // });
        // console.log(obj);
        this.getPopulationList();
        // this.getHistorySignCount()
        // this.visible = this.show
        // this.getProvinceRank()
        // this.getHistorySignCount()
    },
    methods: {
        /** 获取省的总人数，计算参与率用 */
        getPopulationList() {
            populationList.forEach(element => {
                this.populationListMap[element['regionCode']] = element['count']
            });
        },
        // 获取历史签到人数
        getHistorySignCount(year) {
            if (year) {
                api.getExamRank({
                    level: 0,
                    year: year,
                    regionCode: undefined
                }).then(res => {
                    this.currentHistoryYearCount = Number(res.totalCount)
                })
            } else {
                api.getExamRankTotal().then(res => {
                    this.historyCount = Number(res.totalCount)
                })
            }
        },
        // 获取省
        getProvinceRank() {
            this.loadingProvince = true
            this.percentageList[this.yearSelect] = []
            if (this.yearSelect !== this.currentYear && this.cachePercentageList[this.yearSelect] && this.cachePercentageList[this.yearSelect].length > 0) {
                this.percentageList[this.yearSelect] = cloneObj(this.cachePercentageList[this.yearSelect])
                this.provinceList = cloneObj(this.cacheHistoryData[this.yearSelect].province)
                this.loadingProvince = false
                return
            }
            const _yearSelect = this.yearSelect
            addressApi.getAddress({
                code: 0,
                year: Number(_yearSelect),
            }).then(data => {
                console.log('getProvinceAddress=>', data)
                api.getExamRank({
                    level: 0,
                    year: Number(_yearSelect),
                    regionCode: undefined
                }).then(res => {
                    this.count = res.totalCount
                    if (_yearSelect === this.currentYear) {
                        this.currentYearCount = Number(res.totalCount)
                    }
                    console.log('getProvinceRank=>', res)
                    for (let i = 0; i < data.length; i++) {
                        const iElement = data[i]
                        for (let j = 0; j < res.regions.length; j++) {
                            const jElement = res.regions[j]
                            if (jElement.regionCode === iElement.Value) {
                                iElement.count = jElement.count
                                // this.count += iElement.count
                                break
                            }
                        }
                        this.percentageList[_yearSelect].push({
                            count: iElement.count,
                            label: iElement.Label,
                            value: (iElement.count || 0) / this.populationListMap[iElement.Value] * 1000 || 0,
                            percentage: ((iElement.count || 0) / this.populationListMap[iElement.Value] * 1000 || 0).toFixed(2),
                        })
                    }
                    data.sort((a, b) => Number.parseInt(b.count || '0') - Number.parseInt(a.count || '0'))
                    this.percentageList[_yearSelect].sort((a, b) => b.value - a.value)
                    this.provinceList = data || []
                    // 缓存历史数据
                    if (this.yearSelect !== this.currentYear) {
                        this.cacheHistoryData[this.yearSelect]['province'] = cloneObj(this.provinceList)
                        this.cachePercentageList[_yearSelect] = cloneObj(this.percentageList[_yearSelect])
                    }
                    this.loadingProvince = false
                    console.log(data)
                }).catch(e => {
                    console.log('getProvinceRank error=>', e)
                    this.loadingProvince = false
                })
            }).catch(e => {
                console.log('getProvince error=>', e)
                this.loadingProvince = false
            })
        },
        // 获取市
        getCityRank(id) {
            this.loadingCity = true
            if (this.yearSelect !== this.currentYear && this.cacheHistoryData[this.yearSelect]['city'][id]) {
                this.cityList = this.cacheHistoryData[this.yearSelect]['city'][id]
                this.loadingCity = false
                return
            }
            addressApi.getAddress({
                code: id,
                year: Number(this.yearSelect),
            }).then(data => {
                console.log('getCity=>', data)
                api.getExamRank({
                    level: 1,
                    year: Number(this.yearSelect),
                    regionCode: id
                }).then(res => {
                    console.log('getCityRank=>', res)
                    this.count = res.totalCount
                    for (let i = 0; i < data.length; i++) {
                        const iElement = data[i]
                        for (let j = 0; j < res.regions.length; j++) {
                            const jElement = res.regions[j]
                            if (jElement.regionCode === iElement.Value) {
                                iElement.count = jElement.count
                                break
                            }
                        }
                    }
                    data.sort((a, b) => Number.parseInt(b.count || '0') - Number.parseInt(a.count || '0'))
                    this.cityList = data || []
                    // 缓存历史数据
                    if (this.yearSelect !== this.currentYear) {
                        this.cacheHistoryData[this.yearSelect]['city'][id] = cloneObj(this.cityList)
                    }
                    this.loadingCity = false
                }).catch(e => {
                    console.log('getCityRank error=>', e)
                    this.loadingCity = false
                })
            }).catch(e => {
                console.log('getCity error=>', e)
                this.loadingCity = false
            })
        },
        // 获取区县
        getCountyRank(id) {
            this.loadingCounty = true
            if (this.yearSelect !== this.currentYear && this.cacheHistoryData[this.currentYear]['county'][id]) {
                this.countyList = this.cacheHistoryData[this.currentYear]['county'][id]
                this.loadingCounty = false
                return
            }
            addressApi.getAddress({
                code: id,
                year: Number(this.yearSelect),
            }).then(data => {
                console.log('getCounty=>', data)
                api.getExamRank({
                    level: 2,
                    year: Number(this.yearSelect),
                    regionCode: id
                }).then(res => {
                    // if (res.devMessage === "FAIL") {
                    //     this.countyList = data || []
                    //     this.loadingCounty = false
                    //     return
                    // }
                    console.log('getCountyRank=>', res)
                    this.count = res.totalCount
                    for (let i = 0; i < data.length; i++) {
                        const iElement = data[i]
                        for (let j = 0; j < res.regions.length; j++) {
                            const jElement = res.regions[j]
                            if (jElement.regionCode === iElement.Value) {
                                iElement.count = jElement.count
                                break
                            }
                        }
                    }
                    data.sort((a, b) => Number.parseInt(b.count || '0') - Number.parseInt(a.count || '0'))
                    this.countyList = data || []
                    if (this.yearSelect !== this.currentYear) {
                        this.cacheHistoryData[this.currentYear]['county'][id] = this.countyList
                    }
                    this.loadingCounty = false
                }).catch(e => {
                    console.log('getCountyRank error=>', e)
                    this.loadingCounty = false
                })
            }).catch(e => {
                console.log('getCounty error=>', e)
                this.loadingCounty = false
            })
        },
        // 获取街道
        getStreetRank(id) {
            this.loadingStreet = true
            if (this.yearSelect !== this.currentYear && this.cacheHistoryData[this.currentYear]['street'][id]) {
                this.streetList = this.cacheHistoryData[this.currentYear]['street'][id]
                this.loadingStreet = false
                return
            }
            addressApi.getAddress({
                code: id,
                year: Number(this.yearSelect),
            }).then(data => {
                console.log('getStreet=>', data)
                this.loadingStreet = false
                api.getExamRank({
                    level: 3,
                    year: Number(this.yearSelect),
                    regionCode: id
                }).then(res => {
                    // if (res.devMessage === "FAIL") {
                    //     this.streetList = data || []
                    //     this.loadingStreet = false
                    //     return
                    // }
                    console.log('getStreetRank=>', res)
                    this.count = res.totalCount
                    for (let i = 0; i < data.length; i++) {
                        const iElement = data[i]
                        for (let j = 0; j < res.regions.length; j++) {
                            const jElement = res.regions[j]
                            if (jElement.regionCode === iElement.Value) {
                                iElement.count = jElement.count
                                break
                            }
                        }
                    }
                    data.sort((a, b) => Number.parseInt(b.count || '0') - Number.parseInt(a.count || '0'))
                    this.streetList = data || []
                    if (this.yearSelect !== this.currentYear) {
                        this.cacheHistoryData[this.currentYear]['street'][id] = this.streetList
                    }
                    this.loadingStreet = false
                }).catch(e => {
                    console.log('getStreetRank error=>', e)
                    this.loadingStreet = false
                })
            }).catch(e => {
                console.log('getStreet error=>', e)
                this.loadingStreet = false
            })
        },
        /** 点击tab切换 */
        clickTabHandle(index) {
            this.tabActive = index
        },
        /** 点击显示年选择 */
        showYearSelectHandle() {
            this.showYearSelect = true
        },
        /** 点击年 */
        chooseYear(item) {
            this.yearSelect = item.name
            this.showYearSelect = false
            // todo 更新对应年份数据
            this.provinceList = []
            this.tabActive = 0
            this.activeIndex = 0
            this.currentHistoryYearCount = 0
            this.province.id = ''
            this.province.name = ''
            this.resetCity()
            this.resetCounty()
            this.resetStreet()
            this.getProvinceRank()
            this.getHistorySignCount(item.name)
        },
        close() {
            this.visible = false
            this.$emit('close')
        },
        clickHandle(index, id, name) {
            console.log(index, id, name)
            // 判断是否已经选择前一项地址
            if (index === 1 && this.province.id === '') {
                this.$toast.text('请先选择省份')
                return
            } else if (index === 2 && this.city.id === '') {
                this.$toast.text('请先选择城市')
                return
            } else if (index === 3 && this.county.id === '') {
                this.$toast.text('请先选择县/区')
                return
            }

            // 判断激活的下标
            if (index !== undefined && id !== undefined && index !== 3) {
                this.activeIndex = index + 1
            } else if (index !== undefined && id === undefined) {
                this.activeIndex = index
            }
            // 执行对应下标策略（主要是对应地址获取数据）
            this.emitTactics(index, id, name)
        },
        emitTactics(key, id, name) {
            const tactics = {
                0: () => {
                    if (id !== undefined) {
                        if (this.province.id !== id) {
                            this.province.id = id
                            this.province.name = name
                            this.resetCity()
                            this.resetCounty()
                            this.resetStreet()
                            this.getCityRank(id)
                        }
                    }
                    console.log('选择省份')
                    // todo 获取省份
                },
                1: () => {
                    if (id !== undefined) {
                        if (this.city.id !== id) {
                            this.city.id = id
                            this.city.name = name
                            this.resetCounty()
                            this.resetStreet()
                            this.getCountyRank(id)
                        }
                    }
                    console.log('选择市')
                    // todo 获取市
                },
                2: () => {
                    if (id !== undefined) {
                        if (this.county.id !== id) {
                            this.county.id = id
                            this.county.name = name
                            this.resetStreet()
                            this.getStreetRank(id)
                        }
                    }
                    console.log('选择县')
                    // todo 获取县
                },
                3: () => {
                    if (id !== undefined) {
                        this.street.id = id
                        this.street.name = name
                    }
                    console.log('选择街道')
                    // todo 获取街道
                },
            }
            tactics[key]()
        },
        resetCity() {
            this.cityList = []
            this.city.id = ''
            this.city.name = ''
        },
        resetCounty() {
            this.countyList = []
            this.county.id = ''
            this.county.name = ''
        },
        resetStreet() {
            this.streetList = []
            this.street.id = ''
            this.street.name = ''
        },
    }
}
</script>
<style lang="scss" scoped>
.line {
    width: 30px;
    margin: 0 10px;
    display: inline-block;
    height: 1px;
    background-color: #DCDCDC;
}
.mask {
    animation-duration: 0.3s;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.7);
    z-index: 999;
}
.dialog {
    position: fixed;
    max-height: 100%;
    overflow-y: auto;
    width: 100%;
    transition: transform .3s;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 999;
    .dialog-header {
        background: url("./../assets/say-no.png") no-repeat bottom;
        height: 165px;
        background-size: contain;
        margin-bottom: -48px;
        z-index: 1;
        position: relative;
    }
    .dialog-body {
        border-radius: 8px;
        margin: 0 15px;
        background-color: #fff;
        .dialog-body-title {
            padding-top: 15px;
            h1 {
                font-family: SourceHanSansCN-Medium;
                font-size: 16px;
                color: #333333;
                font-weight: 500;
                padding: 10px 20px 10px;
                position: relative;
                background-color: #fff;
                z-index: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                span {
                    color: #dcdcdc;
                }
            }
            p {
                font-size: 14px;
            }
        }
        .list {
            height: 50vh;
            overflow-y: auto;
            padding: 0 15px 0 10px;
        }
        .list-item {
            text-align: left;
            font-size: 13px;
            display: flex;
            align-items: center;
            height: 42px;
            user-select: none;
            &:active {
                background-color: #f5f6f7;
            }
            &.active {
                color: #FF5B5D;
            }
            .list-item--rank {
                width: 50px;
                height: 42px;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    width: 30px;
                }
            }
            .list-item--name {
                flex: 1;
                height: 42px;
                min-width: 50vw;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                display: flex;
                align-items: center;
            }
            .list-item--right {
                height: 42px;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    width: 14px;
                }
            }
        }
    }
    .dialog-footer {
        margin-top: 20px;
        button {
            color: #fff;
            background: transparent;
            border-radius: 50px;
            border: 1px solid #fff;
            width: 130px;
            padding: 10px;
            display: inline-block;
            font-size: 16px;
            font-family: PingFangSC-Medium;
            color: #FFFFFF;
            font-weight: 500;
        }
    }
}
.header {
    height: 50px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #979797;
    .flex-content {
        user-select: none;
        padding: 15px 0;
        font-family: PingFangSC-Regular;
        font-size: 13px;
        letter-spacing: 0;
        font-weight: 400;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        &:active {
            background-color: #f5f6f7;
        }
    }
    .flex-content-light {
        color: #999999;
        &.active {
            color: #FFAC49;
            position: relative;
            &::after {
                content: "";
                position: absolute;
                bottom: 0;
                height: 3px;
                width: 30px;
                background: #FFAC49;
                border-radius: 3px;
                left: 50%;
                transform: translate(-50%, 0);
            }
        }
    }
}
.search-no-data {
    padding: 20px;
    font-size: 14px;
    color: #979797;
    height: 50vh;
    box-sizing: border-box;
}
.history-descript {
    color: #888888;
    margin-top: 10px;
    &.border {
        padding: 18px 0;
        border-bottom: 1px solid #979797;
    }
}
.type {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;

    & > div {
        flex: 1;
        margin: 0 10px;
    }

    .tab {
        flex: 2;
        background: #F1F1F1;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        width: 160px;

        .tab-item {
            flex: 1;
            padding: 5px;
            font-size: 12px;
            
            &.active {
                background: #FFAC49;
                color: #fff;
                border-radius: 8px;
            }
        }
    }

    .year-select {
        background: #F1F1F1;
        border-radius: 13px;
        padding: 7px 0;
        line-height: 16px;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
    }
}
</style>
  